import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { momentLocalizer, Calendar as BigCalendar } from 'react-big-calendar';
import moment from 'moment';
import { CalendarEventDay } from '../CalendarEventLunch';

import { StyledWrapper } from './style';

const localizer = momentLocalizer(moment);

class CalendarFood extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startY: 0,
      currentY: 0,
      move: 0,
      fullDisplacement: false
    };

    this.handleOnTouchStart = this.handleOnTouchStart.bind(this);
    this.handleOnToucEnd = this.handleOnToucEnd.bind(this);
    this.handleOnTransitionEnd = this.handleOnTransitionEnd.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleSingleEventSelection = this.handleSingleEventSelection.bind(
      this
    );
  }

  componentDidMount() {
    // Calculate the max displacement
    // Calendar header:
    const calendarHeader = document.getElementById('calendar-header');
    // This component:
    const calendarEventDay = document.getElementById('calendar-event-day');
    this.setState({
      maxDisplacement:
        calendarHeader.getBoundingClientRect().top +
        calendarHeader.getBoundingClientRect().height -
        calendarEventDay.getBoundingClientRect().top,
      transition: false
    });
  }

  handleOnTransitionEnd() {
    this.setState({ transition: false });
  }

  handleOnTouchStart(e) {
    const { move } = this.state;
    this.setState({
      startY: e.touches[0].clientY - move,
      currentY: e.touches[0].clientY
    });
  }

  handleDrag(e) {
    e.stopPropagation();
    const move = e.touches[0].clientY - this.state.startY;
    const { maxDisplacement } = this.state;
    // Get displacement speed. If it is high enough, this component will move to top or bottom
    const transition = Math.abs(e.touches[0].clientY - this.state.currentY) > 5;
    if (move > 0) {
      // Avoid going under the original position
      this.setState({ move: 0, currentY: e.touches[0].clientY, transition });
    } else if (move > this.state.maxDisplacement) {
      // Drag normaly
      this.setState({ move, currentY: e.touches[0].clientY, transition });
    } else {
      // Avoid going above the calendar header
      this.setState({
        move: maxDisplacement,
        currentY: e.touches[0].clientY,
        transition
      });
    }
  }

  handleOnToucEnd() {
    // Depending on the speed (fullDisplacement) this component will move to top or bottom
    const { maxDisplacement } = this.state;
    if (
      !this.state.fullDisplacement &&
      (this.state.move < this.state.maxDisplacement / 2 ||
        this.state.transition)
    ) {
      this.setState({
        fullDisplacement: true,
        move: maxDisplacement,
        transition: true
      });
    } else if (
      this.state.fullDisplacement &&
      (this.state.move > this.state.maxDisplacement / 2 ||
        this.state.transition)
    ) {
      this.setState({
        fullDisplacement: false,
        move: 0,
        transition: true
      });
    }
  }

  // Action to run when a single event is clicked in the detailed view
  handleSingleEventSelection(id, dateDay) {
    const { showDetail, events } = this.props;
    const event = events.find(ev => ev.id === id).additionalInfo;
    showDetail(event, dateDay);
  }

  render() {
    const { events, components, dateDay, dataEvent } = this.props;

    return (
      <StyledWrapper>
        <BigCalendar
          localizer={localizer}
          events={events}
          popup
          selectable
          views={{
            month: true
          }}
          // eventPropGetter= // personalizar seleccionado
          components={components}
          onSelecting={timeEvent =>
            console.warn('selecting time in hours', timeEvent)
          }
          culture="es"
          onNavigate={() => {}} // Prop to avoid warning
          messages={{
            showMore: count => `+${count}`
          }}
        />
        <CalendarEventDay
          id="calendar-event-day"
          dateDay={dateDay}
          dataEvent={dataEvent}
          onTouchStart={this.handleOnTouchStart}
          onTouchMove={this.handleDrag}
          onTouchEnd={this.handleOnToucEnd}
          onTransitionEnd={this.handleOnTransitionEnd}
          transform={this.state.move}
          transition={this.state.transition}
        />
      </StyledWrapper>
    );
  }
}

CalendarFood.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({})),
  components: PropTypes.shape({}),
  dateDay: PropTypes.string,
  dataEvent: PropTypes.arrayOf(
    PropTypes.shape({
      eventHourStart: PropTypes.string
    })
  )
};

export default CalendarFood;
